<section>
  <div class="container-one">
    <div class="curve top-left-curve"></div>

    <div class="number">
      <img src="/auth/number-three.png" alt="number one image">
    </div>

  </div>

  <div class="container-two">
    <div class="content">
      <h3>Academic Term Configuration</h3>

      <p class="configure">Configure academic terms within the chosen academic year boundary</p>

      <div class="current-aca-year">
        <div><img src="/auth/calender-icon.png" alt="calender icon"></div>

        <p>Active Academic Year</p>

        <h6>{{ academicYearName ?? 'N/A' }}</h6>
      </div>

      <form #termForm="ngForm" (ngSubmit)="addTerm(termForm)">
        <div>
          <label for="termName">Term Name</label>
          <select required [(ngModel)]="termName" name="termName" id="termName">
            <option value="First Term">First Term</option>
            <option value="Second Term">Second Term</option>
            <option value="Third Term">Third Term</option>
          </select>
        </div>

        <div class="form-group">
          <div>
            <label for="startDate">Term Start Date</label>
            <input required [(ngModel)]="startDate" type="date" name="startDate" id="startDate">
          </div>

          <div>
            <label for="endDate">Term End Date</label>
            <input required [(ngModel)]="endDate" type="date" name="endDate" id="endDate">
          </div>
        </div>

        <div>
          <label for="academicTermStatus">Term Status</label>

          <select required [(ngModel)]="status" type="text" name="academicTermStatus" id="academicTermStatus">
            <option value="" hidden disabled>Select a status</option>
            <option value="ACTIVE">Active</option>
            <option value="UPCOMING">Upcoming</option>
            <option value="COMPLETED">Completed</option>
            <option value="CANCELLED">Cancelled</option>
          </select>
        </div>

        @if (status === 'ACTIVE') {
          <div class="checkbox">
            <input [(ngModel)]="currentAcademicTerm" type="checkbox" name="currentAcademicTerm" id="currentAcademicTerm">
            <label for="currentAcademicTerm">Set as current academic term</label>
          </div>
        }

        <div class="note">

          <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

          <div>
            <p>Term dates must fall strictly within the boundaries of the parent Academic Year ({{ academicYearStartDate ?? 'N/A' }} - {{ academicYearEndDate ?? 'N/A' }}).</p>
          </div>
        </div>

        <div class="foot">
          <button routerLink="/school-onboarding/academic-year-configuration" class="button back-button" type="button"><img src="/auth/back-arrow.png" alt="back arrow"> Back</button>

          <button [disabled]="termForm.invalid" class="button submit-button" type="submit">
            @if (isLoading()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Finish Setup
            }
          </button>
        </div>

      </form>


    </div>
  </div>

  <div class="curve bottom-right-curve"></div>

</section>
